import axios from 'axios'
import lang from '@data/lang.json'

const StoreSelect = {
  // Props
  props: [
    'options'
  ],
  // Data
  data () {
    return {
      isToggled: false,
      lang: lang.StoreSelect,
      selectedOption: 0
    }
  },
  // Methods
  methods: {
    onStoreSelect: function() {
      const newUrl = this.selectedOption !== 0 && this.selectedOption !== null && this.selectedOption !== 'undefined'
        ? this.selectedOption
        : window.location.href

      window.location.href = newUrl
    }
  },
}

export default StoreSelect
